/* eslint-disable no-extend-native */

declare global {
  interface String {
    truncate(length?: number, suffix?: string): string;
    capitalizeFirst(): string;
  }
}

String.prototype.truncate = function (length: number = 75, suffix: string = '...'): string {
  const str = this.toString();
  return str.length > length ? str.slice(0, length) + suffix : str;
};

String.prototype.capitalizeFirst = function (): string {
  const str = this.toString();
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export {};
